import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useModuleData from "../../hooks/useFetchItems";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";

export default function InsuranceCoverage() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const AddInsurance = () => {
    history.push("/insurance_new");
  };
  const { tableData } = useModuleData(["Insurance Products"], setLoading);
  console.log("checking table", tableData);
  const columns = [
    {
      title: "Nickname",
      dataIndex: "Nickname",
      key: "Nickname",
    },
    {
      title: "Owner",
      dataIndex: "Owner",
      key: "Owner",
    },
    {
      title: "Insured",
      dataIndex: "Insured",
      key: "Insured",
    },
    {
      title: "Names",
      dataIndex: "Name",
      key: "Name",
      render: (names) => names.join(", "),
    },
    {
      title: "Percents",
      dataIndex: "Percent",
      key: "Percent",
      render: (percents) => percents.join(", "),
    },
    {
      title: "Carrier",
      dataIndex: "Carrier",
      key: "Carrier",
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
    },
    {
      title: "Premium Type",
      dataIndex: "Select Annual/Monthly Premium",
      key: "premiumType",
    },
    {
      title: "Deductible",
      dataIndex: "Deductible",
      key: "Deductible",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Cash Value",
      dataIndex: "Cash Value (if applicable)",
      key: "cashValue",
      render: (value) => (value ? `$${value.toLocaleString()}` : "N/A"),
    },
    {
      title: "Face Value",
      dataIndex: "Face Value",
      key: "Face Value",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Current Annual Income",
      dataIndex: "Current Annual Income",
      key: "Current Annual Income",
      render: (value) => `$${value.toLocaleString()}`,
    },
  ];
  return (
    <>
      <div className="parent-title-container">
        <h2 className="parent-title">Insurance Coverage</h2>
        <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      {
        <CollapseableTable title={"Insurance Coverage"} onClick={AddInsurance}>
          <Table columns={columns} dataSource={tableData.insuranceProductsData} />
          <NewLoader isLoading={loading} />
        </CollapseableTable>
      }
    </>
  );
}
